export const getBootstrapColorName = (hex) => {
  const colors = {
    "#ddd": "muted",
    "#186BAF": "primary",
    "#20a8d8": "primary",
    "#18AF5C": "success",
    "#4dbd74": "success",
    "#DFD734": "warning",
    "#ffc107": "warning",
    "#DC1E27": "danger",
    "#f86c6b": "danger"
  };
  return colors[hex];
};
